import { render, staticRenderFns } from "./AdminSettingsSidebar.vue?vue&type=template&id=5cc176b0&scoped=true"
import script from "./AdminSettingsSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSettingsSidebar.vue?vue&type=script&lang=js"
import style0 from "./AdminSettingsSidebar.vue?vue&type=style&index=0&id=5cc176b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc176b0",
  null
  
)

export default component.exports